import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { getPlural } from '@src/utils/getPlural';
import React, { FC } from 'react';

interface IBundleButtonsProps {
  isShowBonuses: boolean;
  handleShowBonuses: () => void;
  bonusesCount?: number;
  isMulti?: boolean;
  buttonCb: () => void;
  mainButtonText: string;
  arrowBonus?: boolean;
  isWide?: boolean;
}

export const BundleButtons: FC<IBundleButtonsProps> = ({
  isShowBonuses,
  handleShowBonuses,
  bonusesCount,
  isMulti,
  buttonCb,
  mainButtonText,
  arrowBonus,
  isWide,
}) => {
  return (
    <Box column={!isWide} gap={8} fullWidth>
      {!isMulti && !arrowBonus && (
        <Button
          id={'showBonusesBundleButton'}
          fullWidth={!isWide}
          view={'secondaryLight'}
          onClick={handleShowBonuses}
          size="md"
        >
          {isShowBonuses
            ? 'Скрыть'
            : `Еще ${bonusesCount} ${getPlural(Number(bonusesCount), ['бонус', 'бонуса', 'бонусов'])}`}
        </Button>
      )}
      <Button id={'actionBundleButton'} fullWidth={!isWide} onClick={buttonCb} size="md">
        {mainButtonText}
      </Button>
    </Box>
  );
};
